/**
 * The decisions behind the Connected apps page (WEB-7107) that don't need React, kept here so they can be
 * tested.
 */

// What kind of app it is, in the user's terms, from the services client type.
export const appKind = app => {
  if (!app) return ''
  if (app.firstParty || app.clientType === 'first_party') return 'BaseMap'
  if (app.clientType === 'consumer_cimd' || app.clientType === 'consumer_dynamic') return 'AI assistant'
  if (app.clientType === 'partner_confidential' || app.clientType === 'partner_public') return 'Partner app'
  return 'App'
}

// Services has no logo for a connected app yet, so the tile shows the first letter of its name.
export const initial = name => {
  const match = (name || '').match(/[A-Za-z0-9]/)
  return match ? match[0].toUpperCase() : '?'
}

// When, phrased to follow a verb: "today", "yesterday", "3 days ago", or "on Sep 3, 2026". Null means unknown:
// services prunes expired tokens, so an app that hasn't been used for a while has no last-used time.
export const describeWhen = (value, now = new Date()) => {
  if (!value) return null
  const date = new Date(value)
  if (isNaN(date.getTime())) return null
  const startOfDay = d => new Date(d.getFullYear(), d.getMonth(), d.getDate()).getTime()
  const days = Math.round((startOfDay(now) - startOfDay(date)) / 86400000)
  if (days <= 0) return 'today'
  if (days === 1) return 'yesterday'
  if (days < 7) return `${days} days ago`
  return `on ${date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' })}`
}

// Scope descriptions come from services, worded as on the consent screen. Fall back to the scope name.
export const scopeLines = app => (app && app.scopes ? app.scopes.map(s => s.description || s.name) : [])
